import { render, staticRenderFns } from "./inputView.vue?vue&type=template&id=4ecf57f6&"
import script from "./inputView.vue?vue&type=script&lang=js&"
export * from "./inputView.vue?vue&type=script&lang=js&"
import style0 from "./inputView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports